import { Component, effect, inject } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { IntercomService } from 'app/core/services/intercom.service';
import { NavigationService } from 'app/core/services/navigation-history.service';
import { AuthService } from 'app/modules/auth/auth.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { subscriptSizing: 'dynamic', floatLabel: 'always' },
    },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: { position: 'above' },
    },
  ],
})
export class AppComponent {
  private _nav = inject(NavigationService);
  private _auth = inject(AuthService);
  private _intercom = inject(IntercomService);
  private _router = inject(Router);

  constructor() {
    effect(() => {
      const profile = this._auth.profile();
      if (profile) {
        this._intercom.boot(profile);
      } else if (profile === null) {
        this._intercom.shutdown();
      }
    });

    this._router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      if (this._auth.profile()) {
        this._intercom.update();
      }
    });
  }
}
